/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Payin admin
 * Payin application
 * OpenAPI spec version: 1.0
 */

/**
 *  - STATUS_CREATED: New requisite in form of order was added to system.
 *  - STATUS_CANCELLED: [Final status] Requisite was cancelled by trader.
 *  - STATUS_SUGGESTED: Requisite was suggested to merchant as candidate for order processing.
 *  - STATUS_ACQUIRED: Requisite was chosen from suggested.
 *  - STATUS_MERCHANT_CONFIRMED: Merchant confirmed that funds were sent to this requisite.
 *  - STATUS_TRADER_CONFIRMED: [Final status] Trader confirmed that he received funds.
 *  - STATUS_WAITING_FOR_PROOFS: Trader asks merchant to provide proofs.
 *  - STATUS_WAITING_PROOFS_APPROVAL: After trader request merchant added proof and now it need trader approval.
 *  - STATUS_ON_INVESTIGATION: Trader claims that he did not receive funds and investigation is started.
 *  - STATUS_EXPIRED: Requisite was not used in time and order expired.
 *  - STATUS_FAILED: [Final status] Order processing failed and payout was not initialized.
 *  - STATUS_PAYOUT_INITIATED: Compensational payout was initiated to trader's requisite.
 *  - STATUS_PAYOUT_COMPLETED: [Final status] Compensational payout was successfully completed.
 */
export enum PayinCommonTraderOrderV1Status {
    STATUS_UNSPECIFIED = 'STATUS_UNSPECIFIED',
    STATUS_CREATED = 'STATUS_CREATED',
    STATUS_CANCELLED = 'STATUS_CANCELLED',
    STATUS_SUGGESTED = 'STATUS_SUGGESTED',
    STATUS_ACQUIRED = 'STATUS_ACQUIRED',
    STATUS_MERCHANT_CONFIRMED = 'STATUS_MERCHANT_CONFIRMED',
    STATUS_TRADER_CONFIRMED = 'STATUS_TRADER_CONFIRMED',
    STATUS_WAITING_FOR_PROOFS = 'STATUS_WAITING_FOR_PROOFS',
    STATUS_WAITING_PROOFS_APPROVAL = 'STATUS_WAITING_PROOFS_APPROVAL',
    STATUS_ON_INVESTIGATION = 'STATUS_ON_INVESTIGATION',
    STATUS_ON_INVESTIGATION_APPROVE = 'STATUS_ON_INVESTIGATION_APPROVE',
    STATUS_ON_INVESTIGATION_DECLINED = 'STATUS_ON_INVESTIGATION_DECLINED',
    STATUS_EXPIRED = 'STATUS_EXPIRED',
    STATUS_FAILED = 'STATUS_FAILED',
    STATUS_PAYOUT_INITIATED = 'STATUS_PAYOUT_INITIATED',
    STATUS_PAYOUT_IN_PROCESS = 'STATUS_PAYOUT_IN_PROCESS',
    STATUS_PAYOUT_COMPLETED = 'STATUS_PAYOUT_COMPLETED',
    STATUS_PAYOUT_FAILED = 'STATUS_PAYOUT_FAILED',
}
